import {omneticApi} from '@dms/api/base';

import {
  CreateQrCodeSettingsApiArg,
  CreateQrCodeSettingsApiResponse,
  DeleteQrCodeSettingsApiArg,
  DeleteQrCodeSettingsApiResponse,
  GetQrCodeSettingsApiArg,
  GetQrCodeSettingsApiResponse,
  UpdateQrCodeSettingsApiArg,
  UpdateQrCodeSettingsApiResponse,
} from './types';

export const accountingNewApi = omneticApi.injectEndpoints({
  endpoints: (build) => ({
    createQrCodeSettings: build.mutation<
      CreateQrCodeSettingsApiResponse,
      CreateQrCodeSettingsApiArg
    >({
      query: (queryArg) => ({
        url: `/dms/v1/accounting/qr-code-setting`,
        method: 'POST',
        body: queryArg.createQrCodeSettingsRequestBody,
      }),
      invalidatesTags: ['QrCodeSettings'],
    }),
    deleteQrCodeSettings: build.mutation<
      DeleteQrCodeSettingsApiResponse,
      DeleteQrCodeSettingsApiArg
    >({
      query: (queryArg) => ({
        url: `/dms/v1/accounting/qr-code-setting/${queryArg.id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['QrCodeSettings'],
    }),
    getQrCodeSettings: build.query<GetQrCodeSettingsApiResponse, GetQrCodeSettingsApiArg>({
      query: (queryArg) => ({
        url: `/dms/v1/accounting/qr-code-setting/${queryArg.id}`,
      }),
      providesTags: (result, error, arg) => [{type: 'QrCodeSettings', id: arg.id}],
    }),
    updateQrCodeSettings: build.mutation<
      UpdateQrCodeSettingsApiResponse,
      UpdateQrCodeSettingsApiArg
    >({
      query: (queryArg) => ({
        url: `/dms/v1/accounting/qr-code-setting/${queryArg.id}`,
        method: 'PUT',
        body: queryArg.updateQrCodeSettingsRequestBody,
      }),
      invalidatesTags: (result, error, arg) => [{type: 'QrCodeSettings', id: arg.id}],
    }),
  }),
});

export const {
  useCreateQrCodeSettingsMutation,
  useDeleteQrCodeSettingsMutation,
  useGetQrCodeSettingsQuery,
  useUpdateQrCodeSettingsMutation,
} = accountingNewApi;
